import { IRecommendationsService } from "@/lib/depict-client/interfaces/IRecommendationsService"
import { RecommendRequestV3 } from "@/lib/depict-client/types/api/RecommendRequestV3"
import { RecommendResponseV3 } from "@/lib/depict-client/types/api/RecommendResponseV3"
import { ClientFetchService } from "@/lib/http/ClientFetchService"
import { FetchService } from "@/lib/http/FetchService"
import { Result } from "@/types/generic/Result"

export class RecommendationsApiService implements IRecommendationsService {
    constructor(private fetchService: FetchService | ClientFetchService) {}

    /**
     * Returns a list of displays.
     * @param {RecommendRequestV3} req
     * @link https://docs.depict.ai/reference/openapi-reference/recommendations-v3/recommendations
     */
    public getProducts = async (
        req: RecommendRequestV3
    ): Promise<Result<RecommendResponseV3>> => {
        return this.fetchService.fetch("/recommend/products", {
            method: "POST",
            body: JSON.stringify(req)
        })
    }
}
